import { MemberFeature, MemberFeatures } from '@trello/product-features';

export function isFeatureEnabled(feature: MemberFeature, products: number[]) {
  return MemberFeatures.isFeatureEnabled(feature, products);
}

export function hasGold(products: number[]) {
  return isFeatureEnabled(MemberFeature.Crown, products);
}
